// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  margin: 10px auto;
  max-width: 1200px;
  box-sizing: border-box;
}

.title {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin: 10px 0 20px;
  text-align: center;
  margin-top: 45px;
}

.plans-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  width: 100%;
  max-width: 1000px;
}

.plan-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.plan-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.popular {
  border-color: #0078d4;
}

.plan-name {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  margin-bottom: 8px;
}

.plan-price {
  font-size: 20px;
  font-weight: 600;
  color: #0078d4;
  margin: 8px 0;
}

.plan-description {
  font-size: 14px;
  color: #555;
  margin-bottom: 12px;
}

.plan-features {
  list-style: none;
  padding: 0;
  font-size: 13px;
  color: #666;
  margin-bottom: 16px;
  text-align: left;
}

.feature-item {
  margin: 4px 0;
  line-height: 1.4;
}

.select-button {
  background-color: #0078d4;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s ease;
  margin-top: auto;
}

.select-button:hover {
  background-color: #005b9f;
}

.popular .select-button {
  background-color: #22c55e;
}

.popular .select-button:hover {
  background-color: #1d9a4b;
}

.enterprise-message {
  font-size: 13px;
  color: #777;
  margin: 16px 0;
  text-align: center;
  padding: 10px;
}

.no-underline {
  text-decoration: none;
}

/* Ajustes responsivos */
@media (max-width: 600px) {
  .container {
    padding: 10px;
  }
  .title {
    font-size: 20px;
  }
  .plan-card {
    padding: 12px;
  }
  .plan-name {
    font-size: 16px;
  }
  .plan-price {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SelectPlan/SelectPlan.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  margin: 10px auto;\n  max-width: 1200px;\n  box-sizing: border-box;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 500;\n  color: #333;\n  margin: 10px 0 20px;\n  text-align: center;\n  margin-top: 45px;\n}\n\n.plans-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  width: 100%;\n  max-width: 1000px;\n}\n\n.plan-card {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 16px;\n  text-align: center;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.plan-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.popular {\n  border-color: #0078d4;\n}\n\n.plan-name {\n  font-size: 18px;\n  font-weight: 600;\n  color: #222;\n  margin-bottom: 8px;\n}\n\n.plan-price {\n  font-size: 20px;\n  font-weight: 600;\n  color: #0078d4;\n  margin: 8px 0;\n}\n\n.plan-description {\n  font-size: 14px;\n  color: #555;\n  margin-bottom: 12px;\n}\n\n.plan-features {\n  list-style: none;\n  padding: 0;\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n.feature-item {\n  margin: 4px 0;\n  line-height: 1.4;\n}\n\n.select-button {\n  background-color: #0078d4;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  margin-top: auto;\n}\n\n.select-button:hover {\n  background-color: #005b9f;\n}\n\n.popular .select-button {\n  background-color: #22c55e;\n}\n\n.popular .select-button:hover {\n  background-color: #1d9a4b;\n}\n\n.enterprise-message {\n  font-size: 13px;\n  color: #777;\n  margin: 16px 0;\n  text-align: center;\n  padding: 10px;\n}\n\n.no-underline {\n  text-decoration: none;\n}\n\n/* Ajustes responsivos */\n@media (max-width: 600px) {\n  .container {\n    padding: 10px;\n  }\n  .title {\n    font-size: 20px;\n  }\n  .plan-card {\n    padding: 12px;\n  }\n  .plan-name {\n    font-size: 16px;\n  }\n  .plan-price {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
